var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('CreateLayout',{attrs:{"title":"New Task","breadcrumbs":_vm.breadcrumbs}},[_c('CreateUpdateTaskAssignToMe',{attrs:{"formHandler":_vm.formHandler,"btnText":"createTask"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }